import { render, staticRenderFns } from "./UserNote.vue?vue&type=template&id=3034c1c8&"
import script from "./UserNote.vue?vue&type=script&lang=js&"
export * from "./UserNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports